var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Receipt',{attrs:{"receipt":_vm.receipt}})
}
var staticRenderFns = []

export { render, staticRenderFns }